import { IIntakeId, IntakeStatus } from 'types';

// Allow the intake in the filter if it does not have a status as Agents etc might not have one
export const filterIntakesByAllowedStatuses = (
  intakeIds: IIntakeId[],
  allowedIntakeStatuses: IntakeStatus[],
): IIntakeId[] =>
  intakeIds.filter(intake => intake.status === undefined || allowedIntakeStatuses.includes(intake.status));
